const ns = "INTEGRATION_STRIPE_CONNECT_AUTH";
export const RECEIVE = `${ns}_RECEIVE`;
export const REQUEST = `${ns}_REQUEST`;
